import { useEffect } from 'react';

function useLockBodyScroll(isOpen) {
    useEffect(() => {
        if (!isOpen) return;
        const html = document.documentElement;
        const body = document.body;
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        const prev = {
            bodyOverflow: body.style.overflow,
            htmlOverflow: html.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        return () => {
            body.style.overflow = prev.bodyOverflow;
            html.style.overflow = prev.htmlOverflow;
            body.style.paddingRight = prev.bodyPaddingRight;
        };
    }, [isOpen]);
}

export function PhotoCreatePopup({
    isOpen, onClose,
    videoActionTitle,
    photoGallery, sampleImages = [],
    onNavigate,
    onSelectExisting,
    // Legacy props kept for backwards compatibility — no longer used in this simplified flow.
    // eslint-disable-next-line no-unused-vars
    videoActionKey, token, user, sampleUrl, setShowLogin, setShowPricing, onPhotoReady, videoReady,
}) {
    useLockBodyScroll(isOpen);

    if (!isOpen) return null;

    const handleCreateNew = () => {
        onClose?.();
        onNavigate?.('photo');
    };

    return (
        <div className="vidPopupOverlay" onClick={onClose}>
            <div className="vidPopup vidPopupWide phCreatePopup" onClick={e => e.stopPropagation()}>
                <button className="vidPopupClose" onClick={onClose}>&times;</button>

                <div className="vidPopupHeader">
                    <h2 className="vidPopupTitle">
                        Pick a photo
                        {videoActionTitle && <span className="phCreateContext"> for <strong>{videoActionTitle}</strong></span>}
                    </h2>
                </div>

                <button className="phCreatePrimaryBtn" onClick={handleCreateNew}>
                    <span className="phCreatePrimaryBtnIcon" aria-hidden="true">✨</span>
                    <span className="phCreatePrimaryBtnText">Create new photo</span>
                    <span className="phCreatePrimaryBtnArrow" aria-hidden="true">→</span>
                </button>

                {sampleImages.length > 0 && (
                    <div className="phCreateExisting">
                        <div className="phCreateExistingLabel">Or pick a preset</div>
                        <div className="phCreateExistingGrid phCreateExistingGrid--samples">
                            {sampleImages.map((url, idx) => (
                                <button
                                    key={`sample-${idx}`}
                                    className="phCreateThumb phCreateThumb--sample"
                                    onClick={() => onSelectExisting?.({ type: 'sample', url, sampleIdx: idx + 1 })}
                                >
                                    <img src={url} alt="" loading="lazy" />
                                    <span className="phCreateThumbBadge">Preset {idx + 1}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                {photoGallery?.length > 0 && (
                    <div className="phCreateExisting">
                        <div className="phCreateExistingLabel">Or pick from your gallery</div>
                        <div className="phCreateExistingGrid">
                            {photoGallery.map((p, idx) => (
                                <button
                                    key={p.media_id || idx}
                                    className="phCreateThumb"
                                    onClick={() => onSelectExisting?.({ type: 'user', url: p.url, mediaId: p.media_id })}
                                >
                                    <img src={p.url} alt="" loading="lazy" />
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
